// extracted by mini-css-extract-plugin
module.exports = {"login":"OpenAdgangsplatform_login__ZKGC5","inline":"OpenAdgangsplatform_inline__XeARs"};